import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { serverUrl } from "@globalConfig";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { getAndClearTrackingReferralParams } from "@hooks/useHashToLocalStoreEvent";
import { trackEvents } from "@/common/events/events";
import { isRangeFilter } from "@/pages/search/searchHooks/utils";
import { handleFilter } from "@/pages/search/searchHooks/filtersHelpers";
import useLocalStorage from "@hooks/useLocalStorage";
export default function filterPageAnalytics(_ref) {
  var page = _ref.page,
    filters = _ref.filters,
    isBrowserBehaviour = _ref.isBrowserBehaviour,
    searchResults = _ref.searchResults,
    location = _ref.location;
  if (!searchResults.metaData) return;
  trackSearchEvents(page, filters, searchResults);
  if (isBrowserBehaviour) {
    unbxdAnalytics({
      action: "browse_impression",
      url: serverUrl + location.pathname + location.search,
      requestId: searchResults.metaData.request_id || "N.A",
      page: searchResults.metaData.category_path || "",
      page_type: "BOOLEAN",
      pids_list: (searchResults.posts || []).map(function (product) {
        return product.uniqueId;
      })
    });
  } else {
    // need to check after testing the browse search
    unbxdAnalytics({
      action: "search_impression",
      query: filters.text || "",
      url: serverUrl + location.pathname + location.search,
      requestId: searchResults.metaData.request_id || "N.A",
      pids_list: (searchResults.posts || []).map(function (product) {
        return product.uniqueId;
      })
    });
  }
}
var _useLocalStorage = useLocalStorage(),
  getLocalStorage = _useLocalStorage.getLocalStorage;
var trackSearchEvents = function trackSearchEvents(page, filters, searchResults) {
  var _window, _window$lastClickedFi, _window3, _window3$lastClickedF, _window4, _window4$lastClickedF, _window5, _window5$lastClickedF, _window6, _window6$lastClickedF, _window7, _window7$lastClickedF;
  filters = handleFilter(filters);
  var isFiltersSearch = Object.keys(filters).filter(function (key) {
    return key !== "text";
  }).length > 0 || filters.text != "";
  if (!searchResults.metaData) return;
  var _useLocalStorage2 = useLocalStorage(),
    removeLocalStorage = _useLocalStorage2.removeLocalStorage;
  var hashObject = getAndClearTrackingReferralParams(false);
  var isBrowseSearch = hashObject.hasOwnProperty("referral_location");
  if (isFiltersSearch) {
    removeLocalStorage("referral_location");
  }
  var isTextSearch = filters.text;
  var searchHistory = JSON.parse(getLocalStorage("searchHistory")) || [];
  var isRecentSearch = searchHistory === null || searchHistory === void 0 ? void 0 : searchHistory.some(function (history) {
    return history.text === filters.text;
  });
  if (isTextSearch) {
    var interactionType = "user input"; // Default

    if (isRecentSearch && location.search.indexOf("fromRecentSearch=1") > -1) {
      interactionType = "recent_search";
    } else if (window.searchSuggestion) {
      interactionType = "query suggest";
    }
    trackEvents("search", {
      search_query: filters.text,
      results_count: searchResults.metaData.productsCount,
      interaction_type: interactionType,
      page_number: page,
      search_pagination: page
    });
    return;
  }
  if (isBrowseSearch && !isTextSearch) {
    var _searchResults$metaDa;
    trackEvents("browse_cars", _objectSpread(_objectSpread({}, hashObject), {}, {
      results_count: searchResults.metaData.productsCount,
      page_number: page,
      category_path: searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$metaDa = searchResults.metaData) === null || _searchResults$metaDa === void 0 ? void 0 : _searchResults$metaDa.category_path //
    }));
    return;
  }
  var filterValue;
  if ((_window = window) !== null && _window !== void 0 && (_window$lastClickedFi = _window.lastClickedFilter) !== null && _window$lastClickedFi !== void 0 && _window$lastClickedFi.length) {
    var _lastClickedFilter$, _window2;
    filterValue = isRangeFilter((_lastClickedFilter$ = lastClickedFilter[0]) === null || _lastClickedFilter$ === void 0 ? void 0 : _lastClickedFilter$.filterField) ? "from ".concat(window.lastClickedFilter[0].range_values.from, ", to ").concat(window.lastClickedFilter[0].range_values.to) : (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.lastClickedFilter.map(function (item) {
      return item.name_en;
    });
  }
  if (!((_window3 = window) !== null && _window3 !== void 0 && (_window3$lastClickedF = _window3.lastClickedFilter) !== null && _window3$lastClickedF !== void 0 && _window3$lastClickedF.length) && !isFiltersSearch) {
    window.lastClickedFilter = null;
    return;
  }
  Array.isArray(filterValue) && (filterValue = filterValue.join(", "));
  trackEvents("filter_search", {
    filter_name: (_window4 = window) !== null && _window4 !== void 0 && (_window4$lastClickedF = _window4.lastClickedFilter) !== null && _window4$lastClickedF !== void 0 && _window4$lastClickedF.length ? (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$lastClickedF = _window5.lastClickedFilter[0]) === null || _window5$lastClickedF === void 0 ? void 0 : _window5$lastClickedF.filterField : null,
    filter_value: filterValue ? filterValue : null,
    results_count: searchResults.metaData.productsCount,
    page_number: page
  });
  unbxdAnalytics({
    action: "filter_search",
    filter_name: (_window6 = window) !== null && _window6 !== void 0 && (_window6$lastClickedF = _window6.lastClickedFilter) !== null && _window6$lastClickedF !== void 0 && _window6$lastClickedF.length ? (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$lastClickedF = _window7.lastClickedFilter[0]) === null || _window7$lastClickedF === void 0 ? void 0 : _window7$lastClickedF.filterField : null,
    filter_value: filterValue ? filterValue : null,
    results_count: searchResults.metaData.productsCount,
    page_number: page,
    requestId: searchResults.metaData.request_id || "N.A"
  });
  window.lastClickedFilter = null;
};